// extracted by mini-css-extract-plugin
export default {"chartsWrapper":"insight-page_chartsWrapper__GnrBC","dataWrapper":"insight-page_dataWrapper__fCoW5"};